import { observer } from 'mobx-react';
import React, { useCallback, useEffect } from 'react';
import CorpListStore from './corp-list-store';
import CorpListSelectedInfoPopup from './corp-list-selected-info-popup';

const CorpListSelectedInfoPopupContainer = () => {
  const { selectedInfoList, visibleSelectedInfoPopup } = CorpListStore;

  useEffect(() => {
    // console.log('CorpListSelectedInfoPopupContainer > useEffect()');
  }, []);

  const onClickDelete = useCallback(async () => {
    if (
      window.confirm(
        '법인등록 해지처리 하시겠습니까?\n(※등록해지 후 등록→전화번호 조회로 재등록 가능합니다.)'
      )
    ) {
      const customerCode = selectedInfoList
        .map((data) => data.CustomerCode)
        .join(',');

      // console.log(customerCode);

      const result = await CorpListStore.deleteUserInfo(customerCode);

      if (result.error) {
        alert(result.message);
      } else {
        CorpListStore.setVisibleSelectedInfoPopup(false);
        CorpListStore.getUserList();
      }
    }
  }, [selectedInfoList]);

  if (!selectedInfoList) {
    return;
  }

  return (
    <CorpListSelectedInfoPopup
      onHiding={() => CorpListStore.setVisibleSelectedInfoPopup(false)}
      onClickDelete={onClickDelete}
      selectedInfoList={selectedInfoList}
      visibleSelectedInfoPopup={visibleSelectedInfoPopup}
    />
  );
};

export default React.memo(observer(CorpListSelectedInfoPopupContainer));
